<!-- ListCellFeatured.vue -->
<script setup lang="ts">
  import { ICellFeaturedProps } from '@/types'
  import { Typography } from '@components/index'
  import loadIcon from '@utils/loadIcon'

  const props = defineProps<ICellFeaturedProps>()
  const onClick = props.onClick ?? (() => {})

  const handleFeaturedClick = () => {
    onClick()
  }
</script>

<template>
  <div
    :id="props.id"
    class="cell-wrapper d-flex align-items-center p-4 rounded-3 justify-content-between mb-2"
    @click="handleFeaturedClick"
  >
    <div class="px-2">
      <Typography
        variant="news-title"
        class="cell-title flex-grow-1"
      >
        {{ props.title }}
      </Typography>
      <Typography
        variant="news-description"
        class="cell-title flex-grow-1"
      >
        {{ props.purpose }} - {{ props.code }}
      </Typography>
    </div>
    <i
      class="cell-icon ms-3"
      :class="loadIcon('arrow-right-square-fill')"
    />
  </div>
</template>

<style scoped lang="scss">
  .cell-wrapper {
    cursor: pointer;
    background-color: #2d3034;
    min-height: 76px;
  }

  .cell-title {
    padding-inline: 0px;
  }

  .cell-icon {
    height: 16px;
    width: 16px;
  }
</style>
